module.exports = __webpack_public_path__ + "img/Cup.27b154d3.png";